import { AdminAccessSummary, AdminCompanySummary, PlanSummary } from './planTypes';
import { TEXTOS_DE_NAVEGACION, TextosDeNavegacion } from './navTextos';

/**
 * Copia literal de planDisplayHelpers.ts (rama feature/resumen-multi-plan) —
 * planSubtitle/planDisplayName/adminMenuLabel, los que consumen
 * SidebarPlanSelector y SidebarUserMenu.
 */
const planEurFormatter = new Intl.NumberFormat('es-ES', {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
	useGrouping: true
});

/** Cuando no se sabe el saldo. Misma raya que usa chirigota (`planDisplay.ts:61`). */
const SALDO_DESCONOCIDO = '—';

/**
 * Total ahorrado del plan (el nombre de la empresa ya va en el nombre del plan de empleo).
 *
 * 🔴 Sin saldo se devuelve una raya, NO «0 €». Antes hacía `plan.valor ?? 0`, y eso no es
 * formatear: es inventarse un dato. En un producto de pensiones un «0 €» donde no se ha podido
 * consultar el saldo se lee como «no tienes nada», que es justo lo contrario de «no lo sabemos».
 *
 * La raya es la misma que ya usa chirigota, y eso importa: la condición de esta épica es que sus
 * bloques se puedan sustituir por estos SIN que cambie nada de lo que se ve.
 */
export const planSubtitle = (plan: PlanSummary): string =>
	plan.valor === undefined || plan.valor === null
		? SALDO_DESCONOCIDO
		: `${planEurFormatter.format(plan.valor)} €`;

// "Plan de empleo · Empresa", no un nombre distinto solo para el sidebar.
export const planDisplayName = (plan: PlanSummary): string =>
	plan.kind === 'EMPLEO' && plan.entity ? `${plan.name} · ${plan.entity}` : plan.name;

// Etiqueta del acceso admin dentro del menú de usuario: "Admin Empresa" con una
// sola SL administrada, "Admin N empresas" si administra varias.
export const adminMenuLabel = (
	access: AdminAccessSummary,
	textos: Pick<
		TextosDeNavegacion,
		'adminDeUnaEmpresa' | 'adminDeVariasEmpresas'
	> = TEXTOS_DE_NAVEGACION
): string =>
	access.companies.length === 1
		? // Con una función: un `$` en el nombre de la empresa no se lee como patrón de `replace`.
			textos.adminDeUnaEmpresa.replace('{empresa}', () => access.companies[0].name)
		: textos.adminDeVariasEmpresas.replace('{n}', () => String(access.companies.length));

/** Total ahorrado de la empresa, en el desplegable de empresas de Admin. */
export const companySubtitle = (company: AdminCompanySummary): string =>
	`${planEurFormatter.format(company.totalSavedEur)} €`;
